<template>
  <v-app>
    <v-card width="1024" flat class="mx-auto my-auto pb-16">
    <v-container class="mx-auto mt-8">
      <v-row
        cols="12"
        class="d-flex flex-column align-content-md-center mx-auto">
        <v-col cols="4">
          <router-link
										:to="{
											path: '/',
										}">
          <v-img class="mx-auto" src="/images/logo-black.svg" max-width="88">
          </v-img>
        </router-link>
        </v-col>

        <v-col cols="4" class="text-center">
          <h6>
            <v-icon dense class="material-icons">mail_outline</v-icon> Ingrese
            el correo electronico de su cuenta.
          </h6>
        </v-col>
        <v-col cols="4" class="pa-md-0">
          <form @submit.prevent="resetPassword" autocomplete="off">
            <v-text-field
              label="Correo electronico"
              height="56"
              outlined
              required
              v-model="email"
              :rules="emailRules"></v-text-field>
              <v-btn block rounded height="44px" color="primary" type="submit"> Enviar </v-btn>
          </form>
        </v-col>

        <v-col cols="4" class="d-flex flex-column pa-md-0">
          
          <router-link :to="{ path: '/login' }">
            <v-btn
              class="mt-4"
              color="outline "
              text-color="primary"
              height="44px"
              outlined
              rounded
              block
              >Iniciar Sesión</v-btn
            >
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
  </v-app>
</template>
<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //vm.$store.dispatch('fetchAccessToken');
      if (vm.$store.state.user.accessToken != null) {
        next("/");
      }
    });
  },
  created() {
    document.title = "Olvide mi contraseña - TicketShop";
  },
  data() {
    return {
      email: null,
      emailRules: [
        (v) => /.+@.+/.test(v) || "Direccion de correo electronico incorrecta",
      ],
    };
  },
  methods: {
    resetPassword() {
      this.$store.dispatch("resetPassword", { email: this.email }).then(() => {
        // this.email = null;
        // this.$router.push("/");
      });
    },
  },
};
</script>
<style scoped></style>
